import "core-js/modules/es.array.concat.js";
var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', _vm._g(_vm._b({
        ref: "popup",
        class: _vm.$style.popup,
        style: {
            position: _setup.position,
            top: _setup.transformY !== '' ? 0 : '50%',
            transform: "translate3d(-50%, ".concat(_setup.transformY, ", 0)")
        },
        attrs: {
            "position": "center",
            "closeable": "",
            "close-icon-position": "top-left",
            "close-on-click-overlay": false,
            "round": "",
            "get-container": "body",
            "value": _vm.value
        }
    }, 'x-popup', _vm.$attrs, false), _vm.$listeners), [
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('div', {
                class: _vm.$style.tips
            }, [
                _c('h3', [
                    _vm._v("Ingrese el código de verificación")
                ]),
                _c('div', {
                    class: _vm.$style.sendContainer
                }, [
                    _vm.phoneNumber ? _c('p', [
                        _vm._v(" Enviado a " + _vm._s(_setup.desensitize(String(_vm.phoneNumber), 'phoneNumber')) + " ")
                    ]) : _vm._e(),
                    _vm.showResend ? _c('div', {
                        class: _vm.$style.sendCaptcha
                    }, [
                        _setup.sending ? _c('p', [
                            _vm._v("Enviando...")
                        ]) : [
                            _setup.counting ? _c('van-count-down', {
                                ref: "countdown",
                                class: _vm.$style.countdown,
                                attrs: {
                                    "time": 60 * 1000,
                                    "auto-start": false
                                },
                                on: {
                                    "finish": _setup.onCountdownFinish
                                },
                                scopedSlots: _vm._u([
                                    {
                                        key: "default",
                                        fn: function fn(timeData) {
                                            return [
                                                _c('span', [
                                                    _vm._v("Reenviar después de " + _vm._s(timeData.seconds + 1) + "s")
                                                ])
                                            ];
                                        }
                                    }
                                ], null, false, 3466338580)
                            }) : _vm._e(),
                            !_setup.counting ? _c('button', {
                                class: _vm.$style.resend,
                                attrs: {
                                    "type": "button"
                                },
                                on: {
                                    "click": _setup.send
                                }
                            }, [
                                _vm._v(" Enviar código ")
                            ]) : _vm._e()
                        ]
                    ], 2) : _vm._e()
                ])
            ]),
            _c('div', {
                class: _vm.$style.inputWrapper
            }, [
                _c('van-password-input', {
                    staticStyle: {
                        "padding-right": "1px"
                    },
                    attrs: {
                        "value": _setup.captcha,
                        "mask": false,
                        "length": _vm.maxlength,
                        "focused": _setup.focused
                    }
                }),
                _c('input', {
                    directives: [
                        {
                            name: "model",
                            rawName: "v-model",
                            value: _setup.captcha,
                            expression: "captcha"
                        }
                    ],
                    ref: "input",
                    class: _vm.$style.input,
                    attrs: {
                        "type": "text",
                        "inputmode": "numeric",
                        "autocomplete": "one-time-code",
                        "maxlength": _vm.maxlength
                    },
                    domProps: {
                        "value": _setup.captcha
                    },
                    on: {
                        "focus": _setup.onInputFocus,
                        "blur": _setup.onInputBlur,
                        "input": function($event) {
                            if ($event.target.composing) return;
                            _setup.captcha = $event.target.value;
                        }
                    }
                })
            ], 1)
        ]),
        _c('transition', {
            attrs: {
                "name": "van-fade"
            }
        }, [
            _vm.loading ? _c('div', {
                class: _vm.$style.mask
            }, [
                _c('van-loading', {
                    attrs: {
                        "size": 50
                    }
                })
            ], 1) : _vm._e()
        ])
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
